<template>
  <div :class="classes">
    <div class="map-sidebar__header">
      <a class="map-sidebar__back" @click="toggleVisible">
        <ArrowLeft />
      </a>
      <h3 class="map-sidebar__headline">eFriends in der Umgebung</h3>
    </div>
    <div class="map-sidebar__actions">
      <CubeFilter class="map-sidebar__filter" />
      <SortButton />
    </div>
    <ul class="map-sidebar__list">
      <li v-for="cube in visibleCubes" :key="cube.params.cubeName">
        <SidebarEntry
          :cube="cube"
          @click.native="(event) => onCubeClick(cube, event)"
        />
      </li>
    </ul>
    <button
      class="button button--secondary button--full-width map-sidebar__more-button"
      v-if="cubeDisplayLimit < cubes.length"
      @click.prevent="cubeDisplayLimit += cubeDisplayStep"
    >
      {{ str('efriends.showMore') }}
    </button>
  </div>
</template>

<script>
  import ArrowLeft from '@/components/icons/ArrowLeft'
  import CubeFilter from '@/components/efriends/CubeFilter'
  import SortButton from '@/components/efriends/SortButton'
  import SidebarEntry from '@/components/efriends/SidebarEntry'
  import { sortFactory } from './sortFactory'

  export default {
    name: 'maps-sidebar',
    data() {
      return {
        cubeDisplayLimit: 100,
        cubeDisplayStep: 150,
      }
    },
    components: {
      ArrowLeft,
      CubeFilter,
      SortButton,
      SidebarEntry,
    },
    computed: {
      classes() {
        let result = ['map-sidebar']
        if (this.visible) {
          result.push('map-sidebar--visible')
        }
        return result.join(' ')
      },
      cubes: function () {
        return this.$store.getters
          .allCubesByDistanceFrom({ limit: Infinity })
          .sort(sortFactory(this.$store.state.settings.cubeOrder, this.$store))
      },
      visibleCubes: function () {
        return this.cubes.slice(0, this.cubeDisplayLimit)
      },
      visible: function () {
        return this.$store.state.global.mapSideBar.visible
      },
    },
    methods: {
      toggleVisible() {
        this.$store.commit('hideMapSideBar')
      },
      onCubeClick(cube, event) {
        // Focus needs to leave, so that it's not returned while this is hidden
        event.currentTarget.blur()
        // Using replace here, so that the browser history is not polluted with too many pins
        this.$router.replace({
          name: 'map',
          params: { selected: cube.params.cubeName },
        })
        this.toggleVisible()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .map-sidebar {
    width: $map-sidebar-width-min;
    position: fixed;
    top: 0;
    right: 0;
    bottom: $nav-height;
    background: $white;
    padding: spacer(2) spacer(1);
    overflow-y: auto;
    transition: $transition-base;
    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);

    @media (max-width: $bp-lg - 1px) {
      transform: translateX(100%);

      &--visible {
        transform: translateX(0%);
      }
    }

    @media (min-width: $bp-sm) {
      position: absolute;
      bottom: 0;
      width: $map-sidebar-width-sm;
    }

    @media (min-width: $bp-lg) {
      transform: translateX(0%);
      width: $map-sidebar-width-lg;
    }

    &__header {
      margin-bottom: spacer(1);
      display: flex;
      align-items: center;
    }

    &__back {
      width: 1rem;
      margin-right: spacer(1);
      transition: $transition-base;
      color: $grey-mediumdark;
      display: flex;
      align-items: center;
      transform: rotate(180deg);

      @media (min-width: $bp-lg) {
        display: none;
      }

      &:hover,
      &:focus,
      &:active {
        color: $black;
      }
    }

    &__headline {
      margin: 0;
    }

    &__actions {
      margin-bottom: spacer(3);

      > * + * {
        margin-top: spacer(0.5);
      }
    }

    &__filter {
      display: none;

      @media (min-width: $bp-lg) {
        display: flex;
      }
    }

    &__more-button {
      margin-bottom: spacer(2);
    }

    &__list {
      list-style: none;
      margin: 0 0 spacer(2) 0;
      padding: 0;

      > * + * {
        margin-top: spacer(1);
      }
    }
  }
</style>
